import { useFormikContext } from 'formik'
import { AddServiceLocationFormModel } from '../formModel'
import { useEffect } from 'react'

export function useValidateOnMount() {
  const { setTouched, values, initialValues } =
    useFormikContext<AddServiceLocationFormModel>()

  useEffect(() => {
    if (initialValues?.id) {
      const touchedEmails = values?.emailAddresses.reduce(
        (acc, item) => {
          if (item.emailAddress) {
            acc[item.emailAddress] = true
          }
          return acc
        },
        {} as Record<string, boolean>,
      )
      setTouched({
        address1: true,
        address2: true,
        city: true,
        state: true,
        postalCode: true,
        ...touchedEmails,
      })
    }
  }, [setTouched, values?.emailAddresses, initialValues?.id])
}
